import { Uuid, uuidSerializer } from "@legacy-megarax/common";
import { MSerializers } from "@legacy-megarax/serializers";

export interface CreateTradeRouteInput {
  name: string;
  userId: number;
  route: { customerUuid: Uuid; uuid: Uuid; durationMinutes: number }[];
  distanceMeters: number;
  fullDurationMinutes: number;
}

export const createTradeRouteInputSerializer = MSerializers.object<CreateTradeRouteInput>({
  name: MSerializers.string,
  userId: MSerializers.integer,
  route: MSerializers.array(
    MSerializers.object<{ uuid: Uuid; customerUuid: Uuid; durationMinutes: number }>({
      uuid: uuidSerializer,
      customerUuid: uuidSerializer,
      durationMinutes: MSerializers.integer,
    }),
  ),
  distanceMeters: MSerializers.integer,
  fullDurationMinutes: MSerializers.integer,
});

export interface SaveRouteAsPermanentInput {
  name: string;
  userId: number;
  route: { customerUuid: Uuid; uuid: Uuid; durationMinutes: number }[];
  distanceMeters: number;
  fullDurationMinutes: number;
}

export const saveAsPermanentInputSerializer = MSerializers.object<SaveRouteAsPermanentInput>({
  name: MSerializers.string,
  userId: MSerializers.integer,
  route: MSerializers.array(
    MSerializers.object<{ uuid: Uuid; customerUuid: Uuid; durationMinutes: number }>({
      uuid: uuidSerializer,
      customerUuid: uuidSerializer,
      durationMinutes: MSerializers.integer,
    }),
  ),
  distanceMeters: MSerializers.integer,
  fullDurationMinutes: MSerializers.integer,
});

export interface SaveAndScheduleRouteInput {
  scheduledAt: Date;
  userId: number;
  route: { customerUuid: Uuid; uuid: Uuid; durationMinutes: number }[];
  distanceMeters: number;
  fullDurationMinutes: number;
}

export const saveAndScheduleRouteInputSerializer = MSerializers.object<SaveAndScheduleRouteInput>({
  scheduledAt: MSerializers.dateOnly,
  userId: MSerializers.integer,
  route: MSerializers.array(
    MSerializers.object<{ uuid: Uuid; customerUuid: Uuid; durationMinutes: number }>({
      uuid: uuidSerializer,
      customerUuid: uuidSerializer,
      durationMinutes: MSerializers.integer,
    }),
  ),
  distanceMeters: MSerializers.integer,
  fullDurationMinutes: MSerializers.integer,
});

export interface ScheduleRouteInput {
  scheduledAt: Date;
  userId: number;
}

export const scheduleRouteInputSerializer = MSerializers.object<ScheduleRouteInput>({
  scheduledAt: MSerializers.dateOnly,
  userId: MSerializers.integer,
});

export interface RenameRouteInput {
  name: string;
}

export const renameRouteInputSerializer = MSerializers.object<RenameRouteInput>({
  name: MSerializers.string,
});
